import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/toast/alert.service';
import { AddressService } from './../../../shared/services/address.service';
import { FormGroup } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.css']
})
export class BillingAddressComponent implements OnInit {
  title = "BillingAddress"
  constructor(private loadingService: CustomLoadingService,
    private addressService: AddressService,
    private toastService: AlertService,
    private translate: TranslateService,
    private router: Router) { }
  billing = "billing"
  options = {
    redirectUrl: "/managepractice/locations"

  }
  ngOnInit(): void {
  }

  
  parentFun(addressForm: FormGroup) {

    this.loadingService.show();
    this.addressService.updateAddress(addressForm.value,2).subscribe(res => {

      this.loadingService.hide();
      this.toastService.success(this.translate.instant("RecordSaved"), { keepAfterRouteChange: true });
      this.router.navigate([this.options.redirectUrl])
    }, (error) => {
      this.toastService.error(this.translate.instant("GenericError"), { keepAfterRouteChange: true });
      // this.error = this.translate.instant("Common.Error.Exception");
      this.loadingService.hide();

    }, () => {
      this.loadingService.hide();
    })

  }

}

